import type { FC } from "react";

import dompurify from "isomorphic-dompurify";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui";

import styles from "./DiscountDisclaimerView.module.scss";

const { sanitize } = dompurify;

const normalizeSpaces = (html: string) => html.replace(/&nbsp;/g, " ");

type DiscountDisclaimerViewProps = {
  warningMessage?: string;
  disclaimerMessage?: string;
};

export const DiscountDisclaimerView: FC<DiscountDisclaimerViewProps> = ({ disclaimerMessage, warningMessage }) => {
  const { __ } = useTranslations();

  const alertBannerDescription = (
    <>
      {!!disclaimerMessage && (
        <div
          className={styles.item}
          dangerouslySetInnerHTML={{
            __html: sanitize(normalizeSpaces(disclaimerMessage)),
          }}
        />
      )}
      {!!warningMessage && (
        <div
          className={styles.item}
          dangerouslySetInnerHTML={{
            __html: sanitize(normalizeSpaces(warningMessage)),
          }}
        />
      )}
    </>
  );

  return (
    <div className={styles.container}>
      <AlertBanner
        tone="warning"
        title={__("cart.checkout.discount_disclaimer_title")}
        richDescription={alertBannerDescription}
      />
    </div>
  );
};
